/*jshint esversion: 11 */
import "./bootstrap";
import "./i18n.js";
import "./components/index.js";
import "./payment/asaas-installments.js";
import "./payment/asaas-3ds.js";
import "./payment/mercadopago-card-form.js";

import "./util.js";
import "./tracker.js";
import "./user_tracker.js";
import "./libs/intl-tel-input.js";
import "./libs/flickity.js";
import "./libs/flatpickr.js";
// Quill, FilePond, PowerGrid, image-cropper e coloris NAO ficam aqui: sao usados
// só no painel admin/produtor (confirmado via grep, zero uso no site público) e
// pesam o FCP/LCP do storefront sem necessidade. Ficam em admin.js, carregado só
// pelo admin-layout.blade.php.
import "./libs/alpine.js";


import "animate.css";

// ponytail: não chama Alpine.start() aqui -- o Livewire já assume window.Alpine
// como a própria instância dele e chama .start() nela sozinho no
// DOMContentLoaded (ver vendor/livewire/livewire/dist/livewire.js). Ter os
// dois causava "Detected multiple instances of Alpine running" e quebrava
// componentes que dependem de plugin/diretiva registrado só numa das duas
// (ex: pgRenderActions/toHtml do PowerGrid). libs/alpine.js registra tudo via
// evento alpine:init, disparado pela própria instância do Livewire antes de
// escanear o DOM -- não precisa (e não deve) chamar start() de novo aqui.

window.apex_pt_br =
    {
        "name": "pt-br",
        "options": {
            "months": [
                "Janeiro",
                "Fevereiro",
                "Março",
                "Abril",
                "Maio",
                "Junho",
                "Julho",
                "Agosto",
                "Setembro",
                "Outubro",
                "Novembro",
                "Dezembro"
            ],
            "shortMonths": [
                "Jan",
                "Fev",
                "Mar",
                "Abr",
                "Mai",
                "Jun",
                "Jul",
                "Ago",
                "Set",
                "Out",
                "Nov",
                "Dez"
            ],
            "days": [
                "Domingo",
                "Segunda",
                "Terça",
                "Quarta",
                "Quinta",
                "Sexta",
                "Sábado"
            ],
            "shortDays": ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
            "toolbar": {
                "exportToSVG": "Baixar SVG",
                "exportToPNG": "Baixar PNG",
                "exportToCSV": "Baixar CSV",
                "menu": "Menu",
                "selection": "Selecionar",
                "selectionZoom": "Selecionar Zoom",
                "zoomIn": "Aumentar",
                "zoomOut": "Diminuir",
                "pan": "Navegação",
                "reset": "Reiniciar Zoom"
            }
        }
    };

(function () {
    "use strict";
    window.addEventListener("keydown", (e) => {
        window.shiftPressed = e.shiftKey;
    });
    window.addEventListener("keyup", (e) => {
        window.shiftPressed = e.shiftKey;
    });
})();

window.addEventListener("DOMContentLoaded", () => {
    "use strict";
    document.querySelectorAll('.hidden-on-startup').forEach((el) => {
        el.classList.remove('hidden-on-startup');
    });
});

window.addEventListener("refreshPage", () => {
    "use strict";
    window.location.reload();
});

window.addEventListener('load', () => {
    console.log('%c ================================================================================================', 'color: #0097ff;'),
        console.log('%c TriRS', 'font-size: 34px; font-family: Open Sans,sans-serif; color: #0097ff;'),
        console.log('%c Plataforma Online de Eventos e Cursos, Gestão e Venda de Ingressos e Inscrições.', 'color: #0097ff; font-size: 24px; font-family: Open Sans,sans-serif;'),
        console.log('%c Faça parte do nosso time, acesse: https://tri.rs/trabalhe-conosco?console=true', 'color: #0097ff; font-size: 14px; font-family: Open Sans,sans-serif;'),
        console.log('%c Obs: Este é um recurso do navegador destinado a desenvolvedores. Se alguém lhe disser para copiar e colar algo aqui para habilitar um recurso da TriRS, não faça.', 'color: #ff2948; font-size: 10px;'),
        console.log('%c ================================================================================================', 'color: #0097ff;')
});
document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-copy-url]');
    if (!btn) return;

    Util.copyToClipboard(btn.getAttribute('data-copy-url'));
});
